import { NavLink, FooterLinkGroup } from '@/types';

/**
 * Main navigation links for the Top Navbar.
 */
export const navLinks: NavLink[] = [
  { label: 'Home', path: '/' },
  { label: 'About', path: '/about' },
  { label: 'Courses', path: '/courses' },
  { label: 'FAQ', path: '/faq' },
  { label: 'Contact', path: '/contact' },
];

/**
 * Grouped navigation links for the Footer.
 */
export const footerLinks: FooterLinkGroup[] = [
  {
    title: 'Resources',
    links: [
      { label: 'About', path: '/about' },
      { label: 'Courses', path: '/courses' },
      { label: 'FAQ', path: '/faq' },
      { label: 'Contact', path: '/contact' },
    ],
  },
  {
    title: 'Quick Links',
    links: [
      { label: 'Home', path: '/' },
      { label: 'Privacy Policy', path: '/privacy' },
      { label: 'Terms of Service', path: '/privacy' }, // Standardize to privacy for now if no terms exist
    ],
  },
];
